// easyui-linkbutton.component.ts
// (c) 2016 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-linkbutton',
  template: `
    <div #host>
      <ng-content></ng-content>
    </div>
  `
})
export class EasyuiLinkbuttonComponent implements AfterViewInit {
  private host: any;
  @Input() options: any = {};
  @Input() title: string;
  @Input() icon: string;
  @Input() tipo: string;
  @ViewChild('host') hostElement: ElementRef;

  constructor() { }

  ngAfterViewInit() {
    this.configura(this.options);
  }

  public setText(value: string) {
    if (value) { this.host.linkbutton({ text: value }); }
  }

  public css(value: object) {
    this.host.css(value);
  }

  public on(event: string, callback: Function) {
    this.host.on(event, callback);
  }

  public addClass(cla: string) {
    const ele = this.host.find('.l-btn');
    if (cla) { ele.addClass(cla); }
  }

  public removeClass(cla: string) {
    const ele = this.host.find('.l-btn');
    if (cla) { ele.removeClass(cla); }
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  // metodi privati

  private configura(options: any) {
    this.host = $(this.hostElement.nativeElement);
    let opts: any = {};
    // opts.width = 90
    if (this.tipo) { switch (this.tipo) {
      case 'aggiungi':
        opts.text = 'Aggiungi';
        opts.iconCls = 'nx-icon-aggiungi';
        break;
      case 'modifica':
        opts.text = 'Modifica';
        opts.iconCls = 'nx-icon-visualizza';
        break;
      case 'cancella':
        opts.text = 'Cancella';
        opts.iconCls = 'nx-icon-cancella';
        break;
      case 'ricarica':
        opts.text = 'Ricarica';
        opts.iconCls = 'nx-icon-refresh';
        break;
      case 'stampa':
        opts.text = 'Stampa';
        opts.iconCls = 'nx-icon-stampa';
        break;
      case 'salva':
        opts.text = 'Salva';
        opts.iconCls = 'nx-icon-salva';
        break;
      case 'opzioni':
        opts.text = 'Opzioni';
        opts.iconCls = 'nx-icon-opzioni';
        break;
      case 'zoomplus':
        opts.text = '';
        opts.width = undefined;
        opts.iconCls = 'nx-icon-zoomplus';
        break;
      case 'zoomless':
        opts.text = '';
        opts.width = undefined;
        opts.iconCls = 'nx-icon-zoomless';
        break;
    }
    }
    if (this.title) {
      opts.text = this.title;
    }
    if (this.icon) {
      opts.iconCls = this.icon;
    }
    opts.plain = true;
    opts = Object.assign(opts, options);
    this.host.linkbutton(opts);
    if (opts.fontSize) {
      // this.host.css('font-size',opts.fontSize+'px')
      const t = this.host.find('.l-btn-text');
      t.css('font-size', opts.fontSize);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-linkbutton.component.ts